import React from "react";

const BankDetailsCard = ({ accountNumber, name, bank, branch }) => {
  return (
    <div className="border rounded-lg p-4 shadow-md bg-white text-myBlack w-full sm:w-1/2 md:w-1/3 lg:w-1/4 m-2">
      <h2 className="text-lg font-bold mb-2 text-center">{bank}</h2>
      <p className="text-sm text-gray-700">
        <strong>Account Number:</strong> {accountNumber}
      </p>
      <p className="text-sm text-gray-700">
        <strong>Name:</strong> {name}
      </p>
      <p className="text-sm text-gray-700">
        <strong>Branch:</strong> {branch}
      </p>
    </div>
  );
};

const BankDetails = () => {
  const bankDetails = [
    {
      accountNumber: "3606829",
      name: "P.A.N.D.Prabhashwara",
      bank: "BOC",
      branch: "Mahiyanganaya",
    },
    {
      accountNumber: "058200245824653",
      name: "PAND Prabhashwara",
      bank: "Peoples Bank",
      branch: "Mahiyanganaya",
    },
    {
      accountNumber: "018021130712",
      name: "V.D.G.J. Dharmasiri",
      bank: "HNB",
      branch: "Kandy",
    },
    {
      accountNumber: "1184 5215 2199",
      name: "V.G.D.G.J.M.Dharmasiri",
      bank: "Sampath Bank",
      branch: "Menikhinna",
    },
  ];

  return (
    <div className="bg-myBlue py-8 px-4 rounded-lg">
      <h1 className="text-2xl font-bold text-center mb-8 text-myWhite">Bank Details</h1>
      <div className="flex flex-wrap justify-center">
        {bankDetails.map((detail, index) => (
          <BankDetailsCard
            key={index}
            accountNumber={detail.accountNumber}
            name={detail.name}
            bank={detail.bank}
            branch={detail.branch}
          />
        ))}
      </div>
    </div>
  );
};

export default BankDetails;
